import React, { Component, Fragment } from "react";
import aggregacao from "../../../aggregacao";
import chartConfig from "../../../chartConfig";

const PADDING_MES = "4rem";

// Sem coluna própria de "Unidade" pra não desalinhar com o cabeçalho da
// tabela raiz (Modalidade + COLUNAS_RESUMO_MODALIDADE) — o rótulo do curso
// carrega a unidade junto (necessário pra desambiguar cursos homônimos de
// unidades diferentes quando o filtro global de unidade está em "Todas").
export default class LinhaCurso extends Component {

    constructor(props) {
        super(props);
        this.state = { expandido: false };
    }

    alternarExpansao = () => {
        this.setState((estadoAnterior) => ({ expandido: !estadoAnterior.expandido }));
    }

    render() {
        let { curso, linhasCube } = this.props;
        let { expandido } = this.state;
        let meses = expandido ? aggregacao.detalheMensalCurso(linhasCube, curso.id) : [];

        return (
            <Fragment>
                <tr className="table-light">
                    <td style={{ paddingLeft: "2rem" }} onClick={this.alternarExpansao} className="pointer">
                        {expandido ? "▾" : "▸"} {curso.curso} {curso.unidade ? `— ${curso.unidade}` : ""}
                        {curso.comentario && <i className="nc-icon nc-single-copy-04 ml-1" title={curso.comentario}></i>}
                    </td>
                    {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                        <td key={campo}>{chartConfig.formatarNumeroPtBr(curso[campo])}</td>
                    ))}
                </tr>

                {expandido && meses.map((linha) => (
                    <tr key={linha.mes}>
                        <td style={{ paddingLeft: PADDING_MES }}>{linha.mes}</td>
                        {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                            <td key={campo}>{chartConfig.formatarNumeroPtBr(linha[campo])}</td>
                        ))}
                    </tr>
                ))}
            </Fragment>
        )
    }
}
